const BankAccountState = {
    bankAccounts: {},
    banks: []
};

export default BankAccountState;